import { CMP_PREFIX } from "@/base/constant";
import dayjsGenerateConfig from "rc-picker/es/generate/dayjs";
import type { Dayjs } from "dayjs";
import {
  Calendar as AntdCalendar,
  CalendarProps as AntdCalendarProps,
} from "antd";

const MomentCalendar =
  AntdCalendar.generateCalendar<Dayjs>(dayjsGenerateConfig);

export interface CalendarProps extends AntdCalendarProps<Dayjs> {}

export const calendarPrefixCls = `${CMP_PREFIX}-calendar`;

export const Calendar = ({ ...props }: CalendarProps) => {
  return <MomentCalendar {...props} />;
};
